export const DevelopmentStages = {
  PROSPECTING: 'PROSPECTING',
  DEVELOPMENT: 'DEVELOPMENT',
  NTP: 'NTP',
  CONSTRUCTION: 'CONSTRUCTION',
  OPERATING: 'OPERATING'
};

export const DevelopmentStageDisplay = {
  [DevelopmentStages.PROSPECTING]: 'Prospecting',
  [DevelopmentStages.DEVELOPMENT]: 'Development',
  [DevelopmentStages.NTP]: 'At or near NTP',
  [DevelopmentStages.CONSTRUCTION]: 'Construction',
  [DevelopmentStages.OPERATING]: 'Operating'
};

export const DevelopmentStageRadioOptions = [
  {
    value: DevelopmentStages.PROSPECTING,
    label: DevelopmentStageDisplay[DevelopmentStages.PROSPECTING]
  },
  {
    value: DevelopmentStages.DEVELOPMENT,
    label: DevelopmentStageDisplay[DevelopmentStages.DEVELOPMENT]
  },
  {
    value: DevelopmentStages.NTP,
    label: DevelopmentStageDisplay[DevelopmentStages.NTP]
  },
  {
    value: DevelopmentStages.CONSTRUCTION,
    label: DevelopmentStageDisplay[DevelopmentStages.CONSTRUCTION]
  },
  {
    value: DevelopmentStages.OPERATING,
    label: DevelopmentStageDisplay[DevelopmentStages.OPERATING]
  }
];

export const DevelopmentStageDropdownOptions = [
  {
    value: DevelopmentStages.PROSPECTING,
    text: DevelopmentStageDisplay[DevelopmentStages.PROSPECTING]
  },
  {
    value: DevelopmentStages.DEVELOPMENT,
    text: DevelopmentStageDisplay[DevelopmentStages.DEVELOPMENT]
  },
  {
    value: DevelopmentStages.NTP,
    text: DevelopmentStageDisplay[DevelopmentStages.NTP]
  },
  {
    value: DevelopmentStages.CONSTRUCTION,
    text: DevelopmentStageDisplay[DevelopmentStages.CONSTRUCTION]
  },
  {
    value: DevelopmentStages.OPERATING,
    text: DevelopmentStageDisplay[DevelopmentStages.OPERATING]
  }
];